import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import BaseDialog from "@/components/base-dialog.vue";

type ConfirmationType = "WARNING" | "DANGER";


export default /*#__PURE__*/_defineComponent({
  __name: 'confirmation-popup',
  props: {
    isVisible: { type: Boolean },
    type: null,
    title: null,
    message: null,
    buttonText: null,
    onClose: null,
    onConfirm: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  type: ConfirmationType;
  title: string;
  message: string;
  buttonText?: string;
  onClose: () => void;
  onConfirm?: () => void;
}



const displayButtonText = computed(() => props.buttonText || "Confirm");

const confirmButtonClass = computed(() => {
  return props.type === "WARNING" ? "btn-warning" : "btn-danger";
});

const closeDialog = () => {
  props.onClose();
};

const handleConfirm = () => {
  if (props.onConfirm) {
    props.onConfirm();
  }
  closeDialog();
};

return { __sfc: true,props, displayButtonText, confirmButtonClass, closeDialog, handleConfirm, BaseDialog }
}

})